module.exports = __webpack_public_path__ + "static/Pranav-7e4fa7c3ed15baf830525b21a5e1da09.jpg";